import React, { useMemo } from 'react';
import _ from 'lodash';
import ChartsWrap from '../../components/charts-wrap';
import * as echarts from 'echarts';

type ChartsProps = {
    chartsClassName?: string;
    loading?: boolean;
    title: string;
    xAxis: string[];
    dataSource: DataSource[];
};

type DataSource = {
    label: string;
    data: number[];
};

const CompareCharts: React.FC<ChartsProps> = ({
    chartsClassName = '',
    loading = false,
    title,
    xAxis = [],
    dataSource = [],
}) => {
    const chartsOptions: echarts.EChartsOption = useMemo(
        () => ({
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999',
                    },
                },
            },
            legend: {
                bottom: '0',
                itemWidth: 10,
                itemHeight: 10,
                // itemGap: 20,
            },
            grid: {
                left: '0%',
                right: '0%',
                bottom: '15%',
                width: '100%',
                height: '70%',
                containLabel: true,
            },
            xAxis: [
                {
                    type: 'category',
                    data: xAxis,
                    axisPointer: {
                        type: 'shadow',
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                },
            ],
            yAxis: [
                {
                    type: 'value',
                    // name: '业绩目标',
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                        },
                    },
                    // min: 0,
                    // max: 250,
                    // interval: 50,
                    // alignTicks: true,
                    axisLabel: {
                        formatter: '{value} 万',
                    },
                },
            ],
            series: [
                {
                    name: dataSource[0]?.label,
                    type: 'bar',
                    color: new echarts.graphic.LinearGradient(
                        0,
                        1,
                        0,
                        0,
                        [
                            {
                                offset: 0,
                                color: '#83ABFF', // 0% 处的颜色
                            },
                            {
                                offset: 1,
                                color: '#002BFF', // 100% 处的颜色
                            },
                        ],
                        false,
                    ),
                    itemStyle: {
                        borderRadius: [3, 3, 0, 0],
                    },
                    tooltip: {
                        valueFormatter: (value: any) => {
                            return `${value}万 `;
                        },
                    },
                    label: {
                        show: true,
                        position: 'top',
                    },
                    data: dataSource[0]?.data,
                },
                {
                    name: dataSource[1]?.label,
                    type: 'bar',
                    color: new echarts.graphic.LinearGradient(
                        0,
                        1,
                        0,
                        0,
                        [
                            {
                                offset: 0,
                                color: '#FFEA73', // 0% 处的颜色
                            },
                            {
                                offset: 1,
                                color: '#FF8C00', // 100% 处的颜色
                            },
                        ],
                        false,
                    ),
                    itemStyle: {
                        borderRadius: [3, 3, 0, 0],
                    },
                    tooltip: {
                        valueFormatter: (value: any) => {
                            return `${value}万 `;
                        },
                    },
                    label: {
                        show: true,
                        position: 'top',
                    },
                    data: dataSource[1]?.data,
                },
                {
                    name: dataSource[2]?.label,
                    type: 'line',
                    tooltip: {
                        valueFormatter: (value: any) => {
                            return `${value}万 `;
                        },
                    },
                    color: '#20C7FF',
                    data: dataSource[2]?.data,
                },
                {
                    name: dataSource[3]?.label,
                    type: 'line',
                    tooltip: {
                        valueFormatter: (value: any) => {
                            return `${value}万 `;
                        },
                    },
                    color: '#FF6161',
                    data: dataSource[3]?.data,
                },
            ],
        }),
        [xAxis, dataSource],
    );
    return (
        <ChartsWrap
            chartsClassName={chartsClassName}
            loading={loading}
            title={title}
            chartsOptions={chartsOptions}
        />
    );
};

export default CompareCharts;
